import { createAsyncThunk } from '@reduxjs/toolkit';
import { sendGetRequest, sendPatchRequest } from '../../../api/requestUtil';

export const toggleUpvoteBlog = createAsyncThunk(
  'upvote/toggle',
  async (blogId: number, { getState }) => {
    const state = getState() as AppState;
    const token = state.user.authToken;
    try {
      const response = await sendPatchRequest(
        `/api/blogs/upvote-blog/${blogId}/`,
        {},
        token
      );

      return response;
    } catch (error) {
      throw new Error('Failed to toggle upvote');
    }
  }
);

export const fetchUpvoteBlogStatus = createAsyncThunk(
  'upvote/fetchStatus',
  async (blogId: number, { getState }) => {
    const {
      user: { authToken },
    } = getState() as AppState;
    return sendGetRequest(
      `/api/blogs/upvote-status/${blogId}/`,
      authToken || null
    );
  }
);
